export enum PulseMeterType {
  WATER = "WATER",
  GAS = "GAS",
  POWER = "POWER",
}

export interface PulseMeter {
  deviceId: string;
  type: PulseMeterType;
  pulsesPerUnit: number;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
}
